import { useState, useEffect, useRef } from 'react';

const TECHNIQUES = [
  { id: 'box', label: 'Box 4-4-4-4', inhale: 4, hold1: 4, exhale: 4, hold2: 4 },
  { id: '478', label: '4-7-8', inhale: 4, hold1: 7, exhale: 8, hold2: 0 },
  { id: 'coh', label: 'Coerență 5-5', inhale: 5, hold1: 0, exhale: 5, hold2: 0 },
];

export default function Breath() {
  const [tech, setTech] = useState(TECHNIQUES[0]);
  const [running, setRunning] = useState(false);
  const [phase, setPhase] = useState('Gata?');
  const [count, setCount] = useState('—');
  const [cycle, setCycle] = useState(0);
  const [scale, setScale] = useState(1);
  const intervalRef = useRef(null);

  const stop = () => {
    clearInterval(intervalRef.current);
    setRunning(false);
    setPhase('Gata?');
    setCount('—');
    setCycle(0);
    setScale(1);
  };

  const start = () => {
    setRunning(true);
    const phases = [];
    if (tech.inhale) phases.push({ label: 'Inspiră', dur: tech.inhale, sc: 1.15 });
    if (tech.hold1) phases.push({ label: 'Ține', dur: tech.hold1, sc: 1.15 });
    if (tech.exhale) phases.push({ label: 'Expiră', dur: tech.exhale, sc: 1 });
    if (tech.hold2) phases.push({ label: 'Pauză', dur: tech.hold2, sc: 1 });

    let pi = 0, cnt = 0, cyc = 0;
    const tick = () => {
      const p = phases[pi];
      setPhase(p.label);
      setCount(p.dur - cnt);
      setScale(p.sc);
      cnt++;
      if (cnt > p.dur) {
        cnt = 0; pi++;
        if (pi >= phases.length) { pi = 0; cyc++; setCycle(cyc); }
      }
    };
    tick();
    intervalRef.current = setInterval(tick, 1000);
  };

  useEffect(() => () => clearInterval(intervalRef.current), []);

  const changeTech = (t) => { stop(); setTech(t); };

  return (
    <div className="page" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: 20 }}>
      <div style={{ fontSize: 20, fontWeight: 700, marginBottom: 20, alignSelf: 'flex-start' }}>Respirație ghidată</div>

      {/* Technique selector */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 28, flexWrap: 'wrap', justifyContent: 'center' }}>
        {TECHNIQUES.map(t => (
          <button key={t.id} onClick={() => changeTech(t)} style={{
            border: `1.5px solid ${tech.id === t.id ? 'var(--teal)' : 'var(--border)'}`,
            background: tech.id === t.id ? '#E0F5F7' : 'none',
            color: tech.id === t.id ? 'var(--teal)' : 'var(--muted)',
            borderRadius: 20, padding: '6px 16px', fontSize: 13, cursor: 'pointer', fontWeight: 600,
          }}>
            {t.label}
          </button>
        ))}
      </div>

      {/* Animated circle */}
      <div style={{
        width: 180, height: 180, borderRadius: '50%',
        background: '#E0F5F7',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        marginBottom: 24,
        transform: `scale(${scale})`,
        transition: 'transform 0.8s ease',
      }}>
        <div style={{
          width: 120, height: 120, borderRadius: '50%',
          background: '#9FE1CB',
          display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center',
        }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: '#085041' }}>{phase}</div>
          <div style={{ fontSize: 30, fontWeight: 700, color: '#085041' }}>{count}</div>
        </div>
      </div>

      <div style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 22 }}>
        {cycle > 0 ? `Ciclul ${cycle} · ${tech.label}` : 'Alege o tehnică și apasă Start'}
      </div>

      <button className="btn btn-primary" style={{ minWidth: 140 }} onClick={running ? stop : start}>
        {running ? 'Oprește' : 'Începe'}
      </button>

      {/* Info cards */}
      <div style={{ marginTop: 32, width: '100%' }}>
        <div className="section-label">DESPRE TEHNICI</div>
        {[
          { title: 'Box 4-4-4-4', desc: 'Folosită de militari pentru controlul stresului acut. Echilibrează sistemul nervos rapid.' },
          { title: '4-7-8', desc: 'Dezvoltată de Dr. Weil. Activează răspunsul parasimpatic, ideal înainte de somn.' },
          { title: 'Coerență 5-5', desc: 'Sincronizează bătăile inimii cu respirația. Eficientă în anxietate cronică.' },
        ].map(info => (
          <div key={info.title} className="card" style={{ marginBottom: 10 }}>
            <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 4 }}>{info.title}</div>
            <div style={{ fontSize: 13, color: 'var(--muted)' }}>{info.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
